export default __webpack_public_path__ + "static/media/non-automatic-order-icon.6d6aeea1.svg";